// extracted by mini-css-extract-plugin
export var container = "_dx-0";
export var content = "_dx-3";
export var customerTitle = "_dx-4";
export var empty = "_dx-5";
export var gray = "_dx-6";
export var header = "_dx-7";
export var info = "_dx-8";
export var loading = "_dx-2";
export var loadingCard = "_dx-9";
export var oneLine = "_dx-a";
export var personName = "_dx-e";
export var pillContainer = "_dx-b";
export var selected = "_dx-1";
export var text = "_dx-c";
export var twoLines = "_dx-d";
export var unread = "_dx-f";
export var unreadIndicator = "_dx-g";